<div 
  #sliderWrapper 
  class="slider-control-wrapper"
  [class.is-locked]="currentState === SliderState.SUPERLIKE"
>
  <div 
    #sliderBar 
    class="slider-bar"
    [style.--stop-1-pos.%]="stop1_pos"
    [style.--stop-2-pos.%]="stop2_pos"
    [style.--stop-3-pos.%]="stop3_pos"
  >
    <span 
      *ngIf="!isHolding" 
      class="label position-left"
      [class.label-hidden]="currentState === 'superlike'"
      (click)="selectState(SliderState.SUPERLIKE)"
    >{{'superLike' | translate}}</span>

    <ion-icon
      *ngIf="isHolding" 
      class="shaking-icon position-left" 
      [src]="superlikeIconSrc"
    ></ion-icon>

    <span 
      *ngIf="!isHolding"  
      class="label position-right"
      [class.label-hidden]="currentState === 'like' || currentState === 'superlike'"
      (click)="selectState(SliderState.LIKE)"
    >{{'like' | translate}}</span>

    <ion-icon
      *ngIf="isHolding" 
      class="shaking-icon position-right" 
      [src]="likeIconSrc"
    ></ion-icon>
  </div>

  <div
    #sliderHandle
    class="slider-handle"
    [class.dragging-down]="translateY > 0"
    (pointerdown)="onHoldStart($event)"
    [style.touch-action]="'none'"
    [style.transform]="'translate(-50%, -50%) translateX(' + translateX + 'px) translateY(' + translateY + 'px)'"
  >
    <div class="icon-container">
      <ion-icon
        class="slider-icon"
        [src]="displayLogoIconSrc"
        [style.opacity]="1 - actionIconOpacity"
      ></ion-icon>

      <ion-icon
        *ngIf="visualDirection === 'right'"
        class="slider-icon"
        [src]="likeIconSrc"
        [style.opacity]="actionIconOpacity"
      ></ion-icon>

      <ion-icon
        *ngIf="visualDirection === 'left'"
        class="slider-icon"
        [src]="superlikeIconSrc"
        [style.opacity]="actionIconOpacity"
      ></ion-icon>
    </div>

    <div 
      *ngIf="!isHolding && (currentState === 'idle' || currentState === 'like')" 
      class="chevron-container position-left"
    >
      <ion-icon class="chevron outer" [name]="'chevron-back-outline'"></ion-icon>
      <ion-icon class="chevron inner" [name]="'chevron-back-outline'"></ion-icon>
    </div>

    <div *ngIf="!isHolding  && currentState === 'idle'" class="chevron-container position-right">
      <ion-icon class="chevron outer"  [name]="'chevron-back-outline'"></ion-icon>
      <ion-icon class="chevron inner" [name]="'chevron-back-outline'"></ion-icon>
    </div>

    <div *ngIf="!isHolding  && currentState === 'idle' && enableHide" class="chevron-container position-bottom">
      <ion-icon class="chevron inner" [name]="'chevron-back-outline'"></ion-icon>
      <ion-icon class="chevron outer"  [name]="'chevron-down-outline'"></ion-icon>
    </div>

  </div>
</div>